
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelTopographic from "@/views/评测管理/model/DZModelTopographic";
import DZModelDicConfig from "@/model/DZModelDicConfig";

@Component
export default class Topographic extends Vue{

  @Prop() data;

  @Prop() dic;

  @Watch("data")
  watchData(value: any, oldValue: string){
    if(value){
      this.m_topographic = value
    }
  }

  flag = true
  handle_edit(){
    this.flag = !this.flag
  }

  m_topographic = new DZModelTopographic();

  formData = {
    terrainSlope:[],
    altitude:[],
    lotShape:[],
    flatness:[],
    drainedCondition:[],
    irrigationCondition:[],
    position:[],
    landforms:[]
  }

  dic_config = new DZModelDicConfig();

  arr = ['terrainSlope', 'altitude', 'lotShape', 'flatness',
  'drainedCondition', 'irrigationCondition', 'position', 'landforms']

  @Watch("dic")
  watchDic(value: any, oldValue: string) {
    if(value){
      let idList = []
      this.arr.forEach( a =>{
        idList.push(this.dic_config.get(a))
      })
      value.forEach( d =>{
        let index = idList.indexOf(d.typeId)
        if (index != -1) {
          this.formData[this.arr[index]] = d.dicList
        }
      })
      this.$forceUpdate()
    }
  }

  handle_submit(){
    this.$emit('ny_submit_topographic', this.m_topographic)
    this.handle_edit()
  }
}
